import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import * as BS from 'react-bootstrap';
import * as BSEx from '../../BootstrapExtends';
import Box from '../../atoms/Box';

const scope =
  'frontend.components.SpreadsheetReportConfigs.Form.CustomReportForm';

const CustomReportFormSkeleton = () => {
  return (
    <BS.Form horizontal style={{ lineHeight: '1' }}>
      {/* Basic Info Section */}
      <Box>
        <Box.Header>
          <Box.Title>
            {I18n.t(`${scope}.basicInfoSection.sectionTitle`)}
          </Box.Title>
        </Box.Header>

        <Box.Body>
          {/* Spreadsheet ID */}
          <BSEx.FormGroup>
            <BS.Col componentClass={BS.ControlLabel} sm={2}>
              {I18n.t(`${scope}.basicInfoSection.field.spreadsheetId.label`)}
            </BS.Col>
            <BS.Col sm={6}>
              <Skeleton height={34} />
            </BS.Col>
            <BS.Col componentClass={BS.ButtonToolbar} sm={4}>
              <div style={{ display: 'inline-block', marginRight: '10px' }}>
                <Skeleton height={34} width={40} />
              </div>
              <div style={{ display: 'inline-block', marginRight: '10px' }}>
                <Skeleton height={34} width={54} />
              </div>
              <div style={{ display: 'inline-block' }}>
                <Skeleton height={34} width={96} />
              </div>
            </BS.Col>
          </BSEx.FormGroup>

          {/* Name */}
          <BSEx.FormGroupInline
            label={I18n.t(
              `${scope}.basicInfoSection.field.spreadsheetReportConfigName.label`
            )}
          >
            <Skeleton height={34} />
          </BSEx.FormGroupInline>

          {/* Period */}
          <BSEx.FormGroupInline
            label={I18n.t(`${scope}.sheetConfigSection.field.period.label`)}
          >
            <Skeleton height={34} />
          </BSEx.FormGroupInline>
        </Box.Body>
      </Box>

      {/* Sheet Config Section */}
      <Box>
        <Box.Header>
          <Box.Title>
            {I18n.t(`${scope}.sheetConfigSection.sectionTitle`)}
          </Box.Title>
        </Box.Header>

        <Box.Body>
          {/* Current Sheet Name */}
          <BSEx.FormGroupInline
            label={I18n.t(
              `${scope}.sheetConfigSection.field.currentSheetName.label`
            )}
          >
            <Skeleton height={34} />
          </BSEx.FormGroupInline>

          <Skeleton height={34} width={96} />
        </Box.Body>
      </Box>

      {/* Schedule Output Section */}
      <Box>
        <Box.Header>
          <Box.Title>
            {I18n.t(`${scope}.scheduleOutputSection.sectionTitle`)}
          </Box.Title>
        </Box.Header>

        <Box.Body>
          {/* Output Frequency */}
          <BSEx.FormGroupInline
            label={I18n.t(
              `${scope}.scheduleOutputSection.field.outputFrequency.label`
            )}
          >
            <Skeleton height={34} />
          </BSEx.FormGroupInline>
        </Box.Body>
      </Box>

      {/* Action Buttons */}
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <BS.ButtonToolbar>
            <div style={{ display: 'inline-block', marginRight: '10px' }}>
              <Skeleton height={34} width={54} />
            </div>
            <div style={{ display: 'inline-block' }}>
              <Skeleton height={34} width={54} />
            </div>
          </BS.ButtonToolbar>
        </div>
        <div>
          <Skeleton height={34} width={100} />
        </div>
      </div>
    </BS.Form>
  );
};

export default CustomReportFormSkeleton;
